import { Table, Button } from "antd";
import { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import KeyActivities from "./KeyActivities";
import { listKeyActivies } from "../../action/costimizev2DashboardAction";
import { Icon } from "@iconify/react";

const KeyActivitiesTable = () => {
  const [tablerecords, setTableRecords] = useState([]);
  const [drawerstatus, setDrawerStatus] = useState(false);
  const [deletestatus, setDeleteStatus] = useState(false);
  const [oldrecords, setOldRecords] = useState();
  const [updatestatus, setUpdateStatus] = useState(true);
  const companyName = localStorage.getItem(
    "CognitoIdentityServiceProvider.company"
  );
  const { selectedTopdate } = useSelector((state) => state.constimize);
  const dispatch = useDispatch();

  useEffect(() => {
    const date = selectedTopdate;

    dispatch(listKeyActivies({ companyName, date }))
      .unwrap()
      .then(({ data }) => {
        const records = data.newfunctionquery22.map((datas) => {
          return {
            action_token: datas.action_token,
            application: datas.application,
            category: datas.category,
            company: datas.company,
            cost_impact: datas.cost_impact,
            date: datas.date,
            description: datas.description,
            key_id: datas.key_id,
            month: datas.month,
            severity: datas.severity,
            action: "",
            type: "data",
          };
        });
        setTableRecords(records);
      })
      .catch((err) => {
        console.log(err.message);
      });
    setTableRecords([]);
  }, [updatestatus, selectedTopdate]);
  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      className: "plat-table-date",
      sorter: (a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return dateA.getTime() - dateB.getTime();
      },
      render: (date) => {
        const formattedDate = new Date(date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
        return <span>{formattedDate}</span>;
      },
    },
    {
      title: "Application Name",
      dataIndex: "application",
      key: "application",
      sorter: (a, b) => {
        return a.application_name > b.application_name ? -1 : 1;
      },
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      sorter: (a, b) => {
        return a.category > b.category ? -1 : 1;
      },
    },
    {
      title: "Descriptions",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Action Taken",
      dataIndex: "action_token",
      key: "action_token",
    },
    {
      title: "Severity",
      dataIndex: "severity",
      key: "severity",
      sorter: (a, b) => {
        return a.severity > b.severity ? -1 : 1;
      },
    },
    {
      title: "Cost Impact",
      dataIndex: "cost_impact",
      key: "cost_impact",
    },
    {
      title: (
        <Dropdown className="plat-costimize-dropdown">
          <Dropdown.Toggle
            className="plat-three-dort plat-tap-menu plat-box-three-dort"
            id="dropdown-button-dark-example1"
            variant="secondary"
          >
            <Icon icon="bi:filetype-csv" class="table-coloum-chart-icon" />
          </Dropdown.Toggle>
          <Dropdown.Menu className="plat-box-menu-list more-details">
            <Dropdown.ItemText className="plat-dropdown-item-text">
              <span className="plat-box-item-title list-expand-left">
                IMPORT TEMPLATE
              </span>
            </Dropdown.ItemText>
            <Dropdown.ItemText className="plat-dropdown-item-text">
              <span className="plat-box-item-title list-expand-left">
                DOWNLOAD TEMPLATE
              </span>
            </Dropdown.ItemText>
          </Dropdown.Menu>
        </Dropdown>
      ),
      dataIndex: "action",
      key: "action",
      // className: "table-edit-list",
      render: (record, index) => {
        if (index.type === "data") {
          const edit = (
            <Dropdown.ItemText
              className="plat-dropdown-item-text"
              onClick={() => showEditRow(index)}
            >
              <span className="plat-box-item-title list-expand-left">Edit</span>
              <span className="plat-box-item-title list-expand-right">
                <Icon
                  icon="material-symbols:edit-outline"
                  class="table-add-records-icon"
                />
              </span>
            </Dropdown.ItemText>
          );

          var addicon = "";

          return (
            <>
              <Dropdown className="plat-costimize-dropdown plat-box-costimize-dropdown">
                <Dropdown.Toggle
                  className="plat-three-dort plat-tap-menu plat-box-three-dort"
                  id="dropdown-button-dark-example1"
                  variant="secondary"
                >
                  <Icon
                    icon="ph:dots-three-bold"
                    class="plat-expandalt-icon-view"
                  />
                </Dropdown.Toggle>
                <Dropdown.Menu className="plat-box-menu-list more-details">
                  {edit}
                  {addicon}
                </Dropdown.Menu>
              </Dropdown>
            </>
          );
        }
      },
    },
  ];
  const tableProps = {};
  const showAddRow = () => {
    setDrawerStatus(true);
    setDeleteStatus(false);
    setOldRecords(null);
  };

  const showEditRow = (data) => {
    setDrawerStatus(true);
    setDeleteStatus(true);
    setOldRecords(data);
  };
  const changeDrawerStatus = () => {
    setDrawerStatus(false);
  };
  return (
    <>
      <KeyActivities
        drawerstatus={drawerstatus}
        changeDrawerStatus={changeDrawerStatus}
        deletestatus={deletestatus}
        setUpdateStatus={setUpdateStatus}
        updatestatus={updatestatus}
        setDrawerStatus={setDrawerStatus}
        oldrecords={oldrecords}
      />
      <div className="budget-allocated-table">
        <h1 className="plat-table-title">Key activities</h1>

        <Button
          type="primary"
          onClick={() => showAddRow()}
          htmlType="submit"
          style={{ background: "#fff", color: "#1c344c", float: "right" }}
        >
          <span>Add</span>
        </Button>

        <div className="table-width">
          <div className="table-planned-actual">
            <Table
              {...tableProps}
              className="savings_new_table"
              columns={columns}
              pagination={true}
              dataSource={tablerecords}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default KeyActivitiesTable;
